module.exports = __webpack_public_path__ + "torpedo.png?7f7a9234e26cd77ef8ccebf549d90774";


//////////////////
// WEBPACK FOOTER
// ./src/assets/torpedo.png
// module id = 753
// module chunks = 0